import './statistics.css';

import * as React from 'react';
import { connect } from 'react-redux';
import { Link, Redirect } from 'react-router-dom';
import Environment from 'src/common/Environment';
import Utility from 'src/common/Utility';
import Group from 'src/entities/Group';
import Member from 'src/entities/Member';

import ToGreen from '../../res/img/to_green.svg';
import Navigation from '../Navigation/global';
import SwitchAdmin from '../Navigation/switchAdmin';

interface IProps {
  group: Group;
  account: Member;
}

interface IState {
  performer_from: number;
  performer_to: number;
  reporter_from: number;
  reporter_to: number;
}

class StatisticsComponent extends React.Component<IProps, IState> {
  constructor(props: any) {
    super(props);
    this.state = {
      performer_from: Date.now() - 31 * 24 * 60 * 60 * 1000,
      performer_to: Date.now(),
      reporter_from: Date.now() - 31 * 24 * 60 * 60 * 1000,
      reporter_to: Date.now()
    };

    this.exportReporterPoints = this.exportReporterPoints.bind(this);
    this.exportMemosWithPoints = this.exportMemosWithPoints.bind(this);
    this.exportMemosRankingByPossession = this.exportMemosRankingByPossession.bind(
      this
    );
  }

  render() {
    if (this.props.group === undefined) {
      return null;
    }

    if (
      !this.props.account.isSystemAdmin &&
      !this.props.group.admins.includes(this.props.account.id)
    ) {
      return (
        <Redirect
          to={{
            pathname: '/' + this.props.group.title + '/memos'
          }}
        />
      );
    }

    return (
      <div id="SettingsStatistics">
        <Navigation group={this.props.group.title} />

        <div id="SwitchAdminContainer">
          <SwitchAdmin isAdmin={true} group={this.props.group} />
        </div>

        <div id="Tabs">
          <Link to={'/' + this.props.group.title + '/settings/members'}>
            <div className="Tab">メンバー管理</div>
          </Link>
          <Link to={'/' + this.props.group.title + '/settings/functions'}>
            <div className="Tab">ファンクション</div>
          </Link>
          <div className="Tab TabSelected">統計情報</div>
        </div>

        <div id="Content">
          <div className="ContentItem">
            <input
              type="date"
              className="InputText"
              value={Utility.dateFormat(
                new Date(this.state.performer_from),
                'yyyy-MM-dd'
              )}
              onChange={this.onChangeItem.bind(this, 'performer_from')}
            />
            <img src={ToGreen} />
            <input
              type="date"
              className="InputText"
              value={Utility.dateFormat(
                new Date(this.state.performer_to),
                'yyyy-MM-dd'
              )}
              onChange={this.onChangeItem.bind(this, 'performer_to')}
            />
            <button onClick={this.exportTaskStatistics.bind(this, 'performer')}>
              実行者の成績
            </button>
          </div>
          <div className="ContentItem">
            <input
              type="date"
              className="InputText"
              value={Utility.dateFormat(
                new Date(this.state.reporter_from),
                'yyyy-MM-dd'
              )}
              onChange={this.onChangeItem.bind(this, 'reporter_from')}
            />
            <img src={ToGreen} />
            <input
              type="date"
              className="InputText"
              value={Utility.dateFormat(
                new Date(this.state.reporter_to),
                'yyyy-MM-dd'
              )}
              onChange={this.onChangeItem.bind(this, 'reporter_to')}
            />

            <button onClick={this.exportTaskStatistics.bind(this, 'reporter')}>
              報告者の成績
            </button>
          </div>
          {/* <div className="ContentItem">
            <button onClick={this.exportReporterPoints}>
              報告責任者の点数合計
            </button>
          </div> */}
          <div className="ContentItem">
            <button onClick={this.exportMemosWithPoints}>
              点数付きメモの一覧
            </button>
          </div>
          <div className="ContentItem">
            <button onClick={this.exportMemosRankingByPossession}>
              メモの抱え込み時間一覧
            </button>
          </div>
        </div>
      </div>
    );
  }

  onChangeItem(type: string, e: any) {
    if (type === 'performer_from') {
      this.setState({
        performer_from: Date.parse(e.target.value)
      });
    } else if (type === 'performer_to') {
      this.setState({
        performer_to: Date.parse(e.target.value)
      });
    } else if (type === 'reporter_from') {
      this.setState({
        reporter_from: Date.parse(e.target.value)
      });
    } else if (type === 'reporter_to') {
      this.setState({
        reporter_to: Date.parse(e.target.value)
      });
    }
  }

  exportTaskStatistics(type: string, e: any) {
    let params;

    if (type === 'performer') {
      params = [
        {
          key: 't',
          value: this.props.account.token
        },
        {
          key: 'from',
          value: this.state.performer_from
        },
        {
          key: 'to',
          value: this.state.performer_to
        }
      ];
    } else {
      params = [
        {
          key: 't',
          value: this.props.account.token
        },
        {
          key: 'from',
          value: this.state.reporter_from
        },
        {
          key: 'to',
          value: this.state.reporter_to
        }
      ];
    }

    const url =
      Environment.server() +
      '/statistics/group/' +
      this.props.group.id +
      '/tasks/' +
      type +
      '?' +
      params.map(p => p.key + '=' + p.value).join('&');
    window.open(url, '_blank');
  }

  exportReporterPoints(e: any) {
    const params = [
      {
        key: 't',
        value: this.props.account.token
      }
    ];
    const url =
      Environment.server() +
      '/statistics/group/' +
      this.props.group.id +
      '/reporter_points' +
      '?' +
      params.map(p => p.key + '=' + p.value).join('&');
    window.open(url, '_blank');
  }

  exportMemosWithPoints(e: any) {
    const params = [
      {
        key: 't',
        value: this.props.account.token
      }
    ];
    const url =
      Environment.server() +
      '/statistics/group/' +
      this.props.group.id +
      '/memos_with_points' +
      '?' +
      params.map(p => p.key + '=' + p.value).join('&');
    window.open(url, '_blank');
  }

  exportMemosRankingByPossession(e: any) {
    const params = [
      {
        key: 't',
        value: this.props.account.token
      }
    ];
    const url =
      Environment.server() +
      '/statistics/group/' +
      this.props.group.id +
      '/memos_ranking_by_possession' +
      '?' +
      params.map(p => p.key + '=' + p.value).join('&');
    window.open(url, '_blank');
  }
}

const mapStateToProps = (state: any, ownProps: any) => ({
  account: state.Account,
  group: state.Group.find(
    (group: Group) => group.title === ownProps.match.params.group
  )
});

const mapDispatchToProps = (dispatch: any) => {
  return {
    props: 'props'
  };
};

const Members = connect(
  mapStateToProps,
  mapDispatchToProps
)(StatisticsComponent);

export default Members;



// WEBPACK FOOTER //
// ./src/components/Settings/statistics.tsx